import {Component} from '@angular/core'
import {MatCard, MatCardContent} from '@angular/material/card'

@Component({
  selector: 'spb-complete',
  templateUrl: './complete.component.html',
  imports: [
    MatCard,
    MatCardContent
  ],
  styleUrl: './complete.component.scss'
})
export class CompleteComponent {

}
